import { MosaicWall, TableActions, TextMosaic, TextMosaicDto, appConfig, pagination } from '@ami/react/core';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { NotificationManager } from 'react-notifications';
import { withRouter } from 'react-router-dom';
import { documentsLookupService } from '../orders/documentsLookupService';
import { DocumentsLookupFilter } from '../orders/filterConfiguration';
import { OrderDocumentsFilterComponent as FilterComponent } from './components/documents-list/OrderDocumentsFilterComponent';
import { OrderDocumentsTable as Table } from './components/documents-list/OrderDocumentsTable';

class OrderDocumentsListPage extends Component {
  constructor() {
    super();
    this.search = this.search.bind(this);
    this.handleBottomScroll = this.handleBottomScroll.bind(this);

    this.state = {
      items: null,
      filter: new DocumentsLookupFilter({searchOption: 1}),
      loading: false,
      hasLoadedAllPages: false,
      page: 0,
      downloadingId: null,
      partNumberPrefix: null,
      serialNumber: null,
      poNumber: null,
      isPublic: appConfig.isCustomerApp,
      searched: false
    };
  }

  static propTypes = {
    history: PropTypes.object.isRequired,
    title: PropTypes.string,
  };

  search() {
    if (this.state.filter.searchOption === 1) {
      if (!this.state.filter.serialNumber) {
        NotificationManager.error("Serial Number is required");
        return;
      }
    } else {
      if (!this.state.filter.poNumber) {
        NotificationManager.error("PO number is required");
        return;
      }
    }

    this.loadPage(0);
    const { partNumberPrefix, serialNumber, poNumber } = this.state.filter;
    this.setState({ partNumberPrefix, serialNumber, poNumber });
  }

  handleBottomScroll() {
    if (!this.state.hasLoadedAllPages) {
      this.loadPage(this.state.page + 1);
    }
  }

  loadPage(page) {
    if (!this.state.loading) {
      this.setState({ loading: true, searched: false, page });
    }

    const filter = new DocumentsLookupFilter(this.state.filter);
    documentsLookupService
      .search(filter, page, this.state.isPublic)
      .then((items) =>
        this.setState({
          items: page === 0 ? items : this.state.items.concat(items),
          hasLoadedAllPages: items.length < pagination.pageSize,
          searched: true,
        })
      )
      .catch(_ => { })
      .finally(() => this.setState({ loading: false }));
  }

  handleOnDownload = (orderId, documentId, downloadingId, isLegacy) => {
    this.setState({ downloadingId });
    const { partNumberPrefix } = this.state.filter;
    const document = this.state.items.find(x=> x.orderId === orderId);
    const serialNumber = document?.serialNumbers[0];

    const filter = new DocumentsLookupFilter({
      orderId,
      documentId,
      partNumberPrefix,
      serialNumber,
    });
    const downloadFunction = isLegacy
      ? documentsLookupService.getLegacyDocumentDownloadUrl
      : documentsLookupService.getDocumentDownloadUrl;
    downloadFunction(filter, this.state.isPublic)
      .then((response) => (window.location = response.url))
      .finally(() => this.setState({ downloadingId: null }));
  };

  onChange = (id) => {
    this.setState(prevState => ({
      filter: {
        ...prevState.filter,
        searchOption: id
      }
    }));
  }

  render() {
    const buttons = [
      { id: 1, label: 'Search by Serial #' },
      { id: 2, label: 'Search by PO #' },
    ];

    const options = buttons.map((x) => (
      <TextMosaic
        widthColumns={5}
        key={x.id}
        data={new TextMosaicDto({ ...x, selected: x.id === this.state.filter.searchOption })}
        onClick={() => this.onChange(x.id)}
      />
    ));

    return (
      <div>
        <div className="flextable">
          <h3 className="flextable-item flextable-primary page-title">
            {this.props.title}
          </h3>
        </div>
        <TableActions>
          <div className="row">
            <div className="col-2"></div>
            <div className="col-10">
              <MosaicWall
                title=""
                childrenContainerClassName="row justify-content-start"
              >
                {options}
              </MosaicWall>
            </div>
          </div>
          <FilterComponent
            filter={this.state.filter}
            onChange={(x) =>
              this.setState({ filter: new DocumentsLookupFilter(x) })
            }
            onFilter={() => this.search()}
            selectedSearchOption={this.state.filter.searchOption}
          />
        </TableActions>
        <Table
          onBottomScroll={this.handleBottomScroll}
          documents={this.state.items}
          onDownload={this.handleOnDownload}
          loading={this.state.loading}
          downloadingId={this.state.downloadingId}
          searched={this.state.searched}
          searchOption={this.state.filter.searchOption}
        />
      </div>
    );
  }
}

const OrderDocumentsList = withRouter(OrderDocumentsListPage);
export { OrderDocumentsList };
